import React, {useCallback} from 'react';
import Icon from 'react-icons-kit';
import {ic_add} from 'react-icons-kit/md/ic_add';
import {ic_clear} from 'react-icons-kit/md/ic_clear';
import './style.css';
import Button from "@ls/react-button";
import Checkbox from "@ls/react-checkbox";

const ComplicationMini = ({idx, Complication, setComplicationDefinition, single, complicationDefinition}) => {
  const setComplication = useCallback((newComplication) => {
    return single ? setComplicationDefinition([newComplication]) : setComplicationDefinition(idx, newComplication)
  }, [idx, setComplicationDefinition, single]);

  return (
    <div className="ComplicationMini__complication__root">
      <div className="ComplicationMini__complication">
        <Complication
          complicationDefinition={complicationDefinition}
          setComplication={setComplication}
        />
      </div>
      {!single && (
        <div className="ComplicationMini__complication__delete">
          <Button
            onButtonClick={() => setComplicationDefinition(idx, null)}
            icon={<Icon icon={ic_clear} style={{display: 'flex', alignItems: 'center', color: '#000'}}/>}
            size="S"
            variation={5}
          />
        </div>
      )}
    </div>
  );
};

const ComplicationMiniSelector = ({
                                    selectedComplicationDefinitions,
                                    setComplicationDefinition,
                                    setComplicationDefinitions,
                                    ComplicationDefinitionClass,
                                    Complication,
                                    complicationTitle,
                                    single,
                                  }) => {

  const hasComplications = selectedComplicationDefinitions && selectedComplicationDefinitions.length > 0;
  const onChangeCheckbox = useCallback(() => {
    if (hasComplications) {
      setComplicationDefinitions([]);
    } else {
      setComplicationDefinitions([ComplicationDefinitionClass.getDefault()]);
    }
  }, [ComplicationDefinitionClass, hasComplications, setComplicationDefinitions]);
  return (
    <div className="ComplicationMini__root">
      <div className="ComplicationMini__checkbox">
        <Checkbox
          label={complicationTitle}
          value={hasComplications}
          onChange={onChangeCheckbox}
        />
      </div>
      {hasComplications && Complication && (
        <div className="ComplicationMini__complications">
          {selectedComplicationDefinitions.map((complicationDefinition, idx) => (
            <ComplicationMini
              key={idx}
              idx={idx}
              Complication={Complication}
              setComplicationDefinition={setComplicationDefinition}
              single={single}
              complicationDefinition={complicationDefinition}
            />
          ))}
          {!single && (
            <div className="ComplicationMini__addMoreBtn">
              <Button
                onButtonClick={() => setComplicationDefinition(selectedComplicationDefinitions.length, ComplicationDefinitionClass.getDefault())}
                icon={<Icon icon={ic_add} style={{display: 'flex', alignItems: 'center', color: '#000'}}/>}
                size="S"
                variation={5}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ComplicationMiniSelector;
